import type { NowContext } from "@hq/core";

/** Props every built-in view accepts. */
export interface ViewProps {
  onOpenTask?: (taskId: string) => void;
  /** Pins the clock; defaults to the shared ticking clock. */
  now?: NowContext;
  className?: string;
}

export const viewClassName =
  "@container/task-view flex min-w-0 flex-col gap-1 [&:not(:has([data-slot=task-board]))>*]:mx-auto [&:not(:has([data-slot=task-board]))>*]:w-full [&:not(:has([data-slot=task-board]))>*]:max-w-3xl";
